module.exports = __webpack_public_path__ + "static/media/grass-1.f4ca6d8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/grass-1.jpg
// module id = 634
// module chunks = 0